export const CLASS_NAMES = {
  wrapper:
    "cursor-pointer p-2 sibling:border-top sibling:border-top-neutral-200 sibling:border-top-solid hover:bg-blue-100",
  wrapperFocused: "bg-blue-100",
  text: "text-12-18-em text-neutral-800",
};
